import type { Drone, DroneTelemetry } from '@shared/types';
import { fleetStatusOf, type FleetStatus } from '../../lib/droneStatus';
import type { FleetLinkState } from '../../drone/store';

/**
 * 由链路状态 + 平台配置推导统一展示状态。
 *
 * 总览卡片、地图标记、列表行都调用这一个函数，保证同一架机在任何位置
 * 显示的状态完全一致（避免「卡片显示飞行中、列表显示离线」这种矛盾）。
 */
export function droneFleetStatus(
  drone: Drone,
  entry: FleetLinkState | undefined,
  now: number,
): FleetStatus {
  const telemetry: DroneTelemetry | null = entry?.telemetry ?? null;
  return fleetStatusOf({
    enabled: drone.enabled,
    hasTelemetry: telemetry !== null,
    ageMs: telemetry ? now - telemetry.receivedAt : null,
    staleAfterMs: drone.staleAfterMs,
    alertLevel: entry?.alertLevel ?? 'nominal',
    inAir: Boolean(telemetry?.flight.inAir),
  });
}

export function droneAircraftLabel(drone: Drone): string {
  return drone.name === '' ? drone.uniqueId : drone.name;
}
